<template>
  <div class="interest-public">
    <mt-header class="title1 new-mint-header" title="订阅" fixed />
    <div class="container">
      <!-- 表单 -->
      <div class="form">
        <!-- 选择产品 -->
        <div class="item" v-if="product.rowVisible">
          <div class="label long">
            <span>产品名称</span>
          </div>
          <div class="value">
            <div class="product" @click="onProductClick">
              <span :class="product.style">{{ form.product }}</span>
              <mt-actionsheet :actions="product.list" v-model="product.visible"> </mt-actionsheet>
            </div>
          </div>
        </div>
        <!-- 手机号 -->
        <div class="item">
          <div class="label long">
            <span>注册手机号后四位</span>
          </div>
          <div class="value">
            <input type="tel" class="text" v-model="form.mobileNum" maxlength="4" placeholder="请输入手机号码后四位" @input="onMobileNumInput" />
          </div>
        </div>
        <!-- 验证码 -->
        <div class="item">
          <div class="label long no-border">
            <span>验证码</span>
          </div>
          <div class="value no-border">
            <input type="tel" class="text" v-model="form.bindCode" maxlength="4" placeholder="请输入验证码" @input="onBindCodeInput" />
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-row">
        <mt-button type="primary" size="large" :disabled="bindBtnDisabled" @click="onBindBtnClick">
          订 阅
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global
    appid,
    request2,
    PUBLIC_PRODUCT
    */

import { Indicator } from 'mint-ui';
import { SendRequest } from '@/api/official';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';

export default {
  name: 'InterestPublicInput',
  data() {
    return {
      ajax: {
        code: '',
        openid: '',
        userInfo: null,
        getOpenidUrl: '',
        getUserInfoUrl: '',
        bindUrl: '',
      },
      form: {
        product: '请选择产品',
        bindCode: '',
        mobileNum: '',
      },
      product: {
        list: [
          {
            name: '易付通',
            method: () => {
              this.product.style = 'word';
              this.form.product = '易付通';
              this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
              this.ajax.getUserInfoUrl = `${request2.yft}api/OfficialAccount/getWXUserInfo`;
              this.ajax.bindUrl = `${request2.yft}api/OfficialAccount/oABind`;
              this.initAll();
            },
          },
          {
            name: '诚享易付',
            method: () => {
              this.product.style = 'word';
              this.form.product = '诚享易付';
              this.ajax.getOpenidUrl = `${request2.cxyf}api/OfficialAccount/GetWXOpenId`;
              this.ajax.getUserInfoUrl = `${request2.cxyf}api/OfficialAccount/getWXUserInfo`;
              this.ajax.bindUrl = `${request2.cxyf}api/OfficialAccount/oABind`;
              this.initAll();
            },
          },
          {
            name: '诚享PLUS',
            method: () => {
              this.product.style = 'word';
              this.form.product = '诚享PLUS';
              this.ajax.getOpenidUrl = `${request2.cxplus}api/OfficialAccount/GetWXOpenId`;
              this.ajax.getUserInfoUrl = `${request2.cxplus}api/OfficialAccount/getWXUserInfo`;
              this.ajax.bindUrl = `${request2.cxplus}api/OfficialAccount/oABind`;
              this.initAll();
            },
          },
          {
            name: '恒付PLUS',
            method: () => {
              this.product.style = 'word';
              this.form.product = '恒付PLUS';
              this.ajax.getOpenidUrl = `${request2.hfplus}api/OfficialAccount/GetWXOpenId`;
              this.ajax.getUserInfoUrl = `${request2.hfplus}api/OfficialAccount/getWXUserInfo`;
              this.ajax.bindUrl = `${request2.hfplus}api/OfficialAccount/oABind`;
              this.initAll();
            },
          },
        ],
        visible: false,
        rowVisible: false,
        style: 'placeholder',
        param: PUBLIC_PRODUCT.toLowerCase().trim() || '',
      },
      isTest: false,
      appid: appid.wx_official_id,
      bindSuccess: false,
    };
  },
  created() {
    if (!this.isTest) {
      const code = this.getUrlKey('code');
      if (code) {
        this.ajax.code = code;
      } else {
        this.getCodeApi(Math.floor(Math.random() * 900000 + 100000));
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bindSuccess = false;
      this.initProduct();
    });
  },
  computed: {
    bindBtnDisabled() {
      return (!this.product.param && this.form.product === '请选择产品') || this.form.bindCode === '' || this.form.mobileNum === '';
    },
  },
  methods: {
    // 获取url中参数
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    },
    // 微信交互，获取code
    getCodeApi(state = '') {
      const appid = this.appid;
      const urlNow = encodeURIComponent(window.location.href);
      const scope = 'snsapi_base'; // snsapi_userinfo   //静默授权 用户无感知
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.replace(url);
    },
    // 接口获取openid
    getOpenid(jsCode = '', ok = null) {
      SendRequest(this.ajax.getOpenidUrl, { jsCode })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data.openid) {
                this.ajax.openid = res.data.openid;
                ok && ok();
              } else {
                CusToast('openid为空');
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 接口获取userinfo
    getUserInfo(openId = '', ok = null) {
      SendRequest(this.ajax.getUserInfoUrl, { openId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data) {
                this.ajax.userInfo = res.data;
                ok && ok();
              } else {
                CusToast('data不存在');
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 初始化所有数据
    initAll() {
      this.form.bindCode = '';
      this.form.mobileNum = '';
      this.bindSuccess = false;
    },
    // 根据url产品标识初始化选择产品行
    initProduct() {
      if (this.product.param) {
        this.product.rowVisible = false;
        switch (this.product.param) {
          case 'yft':
            this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
            this.ajax.getUserInfoUrl = `${request2.yft}api/OfficialAccount/getWXUserInfo`;
            this.ajax.bindUrl = `${request2.yft}api/OfficialAccount/oABind`;
            break;
          case 'cxyf':
            this.ajax.getOpenidUrl = `${request2.cxyf}api/OfficialAccount/GetWXOpenId`;
            this.ajax.getUserInfoUrl = `${request2.cxyf}api/OfficialAccount/getWXUserInfo`;
            this.ajax.bindUrl = `${request2.cxyf}api/OfficialAccount/oABind`;
            break;
          case 'cxplus':
            this.ajax.getOpenidUrl = `${request2.cxplus}api/OfficialAccount/GetWXOpenId`;
            this.ajax.getUserInfoUrl = `${request2.cxplus}api/OfficialAccount/getWXUserInfo`;
            this.ajax.bindUrl = `${request2.cxplus}api/OfficialAccount/oABind`;
            break;
          case 'hfplus':
            this.ajax.getOpenidUrl = `${request2.hfplus}api/OfficialAccount/GetWXOpenId`;
            this.ajax.getUserInfoUrl = `${request2.hfplus}api/OfficialAccount/getWXUserInfo`;
            this.ajax.bindUrl = `${request2.hfplus}api/OfficialAccount/oABind`;
            break;
          default:
            this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
            this.ajax.getUserInfoUrl = `${request2.yft}api/OfficialAccount/getWXUserInfo`;
            this.ajax.bindUrl = `${request2.yft}api/OfficialAccount/oABind`;
            break;
        }
      } else {
        this.product.rowVisible = true;
      }
    },
    // 接口绑定
    bind(openId, randomCode, unionId) {
      SendRequest(this.ajax.bindUrl, { openId, randomCode, unionId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              Indicator.close();
              this.registerSuccess = true;
              CusToast('绑定成功');
            },
            (code, msg) => {
              Indicator.close();
              code === 1 && CusToast(msg || '绑定失败');
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证码输入事件
    onBindCodeInput() {
      // 获取正在输入的最后一位字符
      const last = this.form.bindCode.charAt(this.form.bindCode.length - 1);
      // 自动将非法字符替换成空
      this.form.bindCode = '1234567890'.indexOf(last) < 0 ? this.form.bindCode.replace(last, '') : this.form.bindCode;
    },
    // 手机号输入事件
    onMobileNumInput() {
      // 获取正在输入的最后一位字符
      const last = this.form.mobileNum.charAt(this.form.mobileNum.length - 1);
      // 自动将非法字符替换成空
      this.form.mobileNum = '1234567890'.indexOf(last) < 0 ? this.form.mobileNum.replace(last, '') : this.form.mobileNum;
    },
    // 绑定按钮事件
    onBindBtnClick() {
      if (this.registerSuccess) {
        CusToast('您已成功订阅，可离开当前页面');
        return;
      }
      Indicator.open();
      this.getOpenid(this.ajax.code, () => {
        this.getUserInfo(this.ajax.openid, () => {
          const param1 = this.ajax.openid;
          const param2 = `${this.form.bindCode}_${this.form.mobileNum}`;
          const param3 = this.ajax.userInfo.unionid;
          this.bind(param1, param2, param3);
        });
      });
    },
    // 产品点击事件
    onProductClick() {
      this.product.visible = true;
    },
  },
};
</script>
